import { Loader } from "@/components/loader";
import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { getListEquipment } from "../../../api/group";
import SearchInput from "../../project/searchInput";
import TableEquipment from "./tableEquipment";

export default function DetailsEquipment({
  setMode,
  notGroup,
  setEquipmentIdFromUpdate,
}) {
  const [dataTable, setDataTable] = useState([]);
  const [valueSearch, setValueSearch] = useState("");

  const [totalSize, setTotalSize] = useState();
  const [loading, setLoading] = useState(false);
  const [lastFetch, setLastFetch] = useState();
  const md = useMediaQuery("(max-width:450px)");

  const [pageable, setPageable] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const fetchData = useCallback(
    (clearSearch) => {
      if (lastFetch !== undefined && Date.now() - lastFetch < 500) return;
      setLoading(true);
      const query = new URLSearchParams();
      query.append("pageIndex", pageable.pageIndex);
      query.append("pageSize", pageable.pageSize);
      if (!clearSearch && valueSearch && valueSearch.length > 1) {
        query.append("name", valueSearch);
      }

      getListEquipment(query)
        .then((res) => {
          setLastFetch(Date.now());
          setDataTable(res.content);
          setTotalSize(res.totalElements);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    },
    [pageable, valueSearch],
  );

  useEffect(() => {
    fetchData(false);
  }, [pageable]);

  const [timer, setTimer] = useState();
  useEffect(() => {
    if (timer !== undefined) {
      clearTimeout(timer);
    }

    if (valueSearch.length >= 2) {
      const timer = setTimeout(() => {
        fetchData(false);
      }, 500);

      setTimer(timer);
    }

    return () => {
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    };
  }, [valueSearch]);

  return (
    <>
      {loading && <Loader />}
      <Box>
        <Grid
          display="flex"
          flexDirection={md ? "column-reverse" : "row"}
          justifyContent={"space-between"}
        >
          <Grid display={"flex"} flexDirection={"row"}>
            <SearchInput
              type="text"
              id="filter-text-box-before-train"
              value={valueSearch}
              onChange={(e) => setValueSearch(e.target.value)}
              mb="5px"
            />
            {valueSearch.length >= 2 && (
              <Button
                onClick={() => {
                  setValueSearch("");
                  fetchData(true);
                }}
              >
                پاک کردن فیلتر
              </Button>
            )}
          </Grid>
          <Button onClick={() => setMode("new")} variant="contained">
            تجهیزات جدید
          </Button>
        </Grid>

        <TableEquipment
          notGroup={notGroup}
          setMode={setMode}
          setEquipmentIdFromUpdate={setEquipmentIdFromUpdate}
          rowData={dataTable}
          setRowData={setDataTable}
          pageable={pageable}
          setPageable={setPageable}
          totalElements={totalSize}
        />
      </Box>
    </>
  );
}
